import React, { createContext, useContext } from 'react';

const StylesApiContext = createContext({
  classNames: {},
  styles: {},
  unstyled: false
});
function StylesApiProvider({
  children,
  classNames,
  unstyled,
  styles,
  staticSelector
}) {
  return /* @__PURE__ */ React.createElement(StylesApiContext.Provider, {
    value: { classNames, styles, unstyled, staticSelector }
  }, children);
}
function useContextStylesApi() {
  return useContext(StylesApiContext);
}

export { StylesApiProvider, useContextStylesApi };
//# sourceMappingURL=StylesApiContext.js.map
